<template>
  <div class="bg-silver">
    <!-- BEGIN #page-header -->
    <div id="page-header" class="section-container page-header-container bg-black">
      <!-- BEGIN page-header-cover -->
      <div class="page-header-cover">
        <img src="/beta/static/img/contact-bg/contact-dev.png" alt="" />
      </div>
      <!-- END page-header-cover -->
      <!-- BEGIN container -->
      <div class="container">
        <h1 class="page-header"><b>Let's be partner</b></h1>
      </div>
      <!-- END container -->
    </div>
    <!-- BEGIN #page-header -->
    <!-- BEGIN #product -->
    <div id="product" class="section-container p-t-20">
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN breadcrumb -->
        <!-- <ul class="breadcrumb m-b-10 f-s-12">
          <li><a href="/">Home</a></li>
          <li><a href="#">Support</a></li>
          <li class="active">Contact Us</li>
        </ul> -->
        <!-- END breadcrumb -->
        <!-- BEGIN row -->
        <div class="row row-space-30">
          <!-- BEGIN col-8 -->
          <div class="col-md-8">
            <h4 class="m-t-0">Build Your Own App</h4>
            <p class="m-b-30 f-s-13">
              Contact us to learn how you can take advantage of being a womia partner, and to turn your idea or algorithm into medical imaging App using womia APIs .
            </p>
            <div :class="message.alert" class="alert text-center" v-if="message.text" role="alert">
              {{ message.text }}
            </div>
            <div class="form-horizontal">
              <div class="form-group">
                <label class="control-label col-md-3">Name <span class="text-danger">*</span></label>
                <div class="col-md-7">
                  <input type="text" class="form-control" name="name" v-model="userContact.name"/>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3">Email <span class="text-danger">*</span></label>
                <div class="col-md-7">
                  <input type="text" class="form-control" name="email" v-model="userContact.email"/>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3">Subject <span class="text-danger">*</span></label>
                <div class="col-md-7">
                  <input type="text" class="form-control" name="subject" v-model="userContact.subject"/>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3">Message <span class="text-danger">*</span></label>
                <div class="col-md-7">
                  <textarea class="form-control" rows="10" name="message" v-model="userContact.message"></textarea>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3"></label>
                <div class="col-md-7">
                  <button class="btn btn-inverse btn-lg" @click="sendContactUsMsg()">Send Message</button>
                </div>
              </div>
            </div>
          </div>
          <!-- END col-8 -->
          <!-- BEGIN col-4 -->
          <div class="col-md-4">
            <div><b>Email</b></div>
            <p class="m-b-15">
              <a href="mailto:hello@womia.io" class="text-inverse">hello@womia.io</a>
              <br />
              <a href="mailto:support@womia.io" class="text-inverse">support@womia.io</a>
              <br />
            </p>
            <div class="m-b-5"><b>Social Network</b></div>
            <p class="m-b-15">
              <a href="#" class="btn btn-icon btn-white btn-circle"><i class="fa fa-facebook"></i></a>
              <a href="#" class="btn btn-icon btn-white btn-circle"><i class="fa fa-twitter"></i></a>
              <a href="#" class="btn btn-icon btn-white btn-circle"><i class="fa fa-linkedin"></i></a>
            </p>
          </div>
          <!-- END col-4 -->
        </div>
        <!-- END row -->
      </div>
      <!-- END row -->
    </div>
    <!-- END #product -->
  </div>
</template>
<script>
export default {
  name: 'ContactUsDev',
  data() {
    return {
      userContact: {},
      message: {}
    }
  },
  methods: {
    showMessage(message) {
      this.message = message
    },
    sendContactUsMsg() {
      this.$http
        .post('contact/contact-us', this.userContact)
        .then(
          response => {
            this.showMessage({ text: 'Your message has been successfully sent', alert: 'alert-success' })
            this.userContact = {}
          },
          err => {
            // error callback
            console.log(err)
            this.showMessage({ text: 'Sorry, your message was not sent. Please fill in all required fields and try again', alert: 'alert-danger' })
          }
        )
    }
  }
}
</script>
<style scoped>
.section-container {
  padding: 100px 0;
}

.page-header-cover:before {
  background: rgba(36, 42, 48, 0.5);
}

.page-header-cover img {
  max-width: 100%;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/public/ContactDeveloper.vue